module.exports = __webpack_public_path__ + "img/stock5.fd728845.png";